import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { FlexLayoutModule } from "@angular/flex-layout";

import { CheckboxModule } from "@bfx/primeng/checkbox";
import { DialogModule } from "@bfx/primeng/dialog";
import { ButtonModule } from "@bfx/primeng/button";
import { OverlayPanelModule } from "@bfx/primeng/overlaypanel";
import { TranslateModule } from "@ngx-translate/core";
import { AgGridModule } from "@bfx/ag-grid-angular";

import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BfxBlotterFilterModule } from "../bfx-blotter-filter/bfx-blotter-filter.module";
import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";
import { BfxVwapModule } from "../bfx-vwap/bfx-vwap.module";
import { BfxBlotterOrdersModule } from "../bfx-blotter-orders/bfx-blotter-orders.module";
import { BfxBlotterInbox } from "./bfx-blotter-inbox";
import { BfxBlotterInboxFilter } from "./bfx-blotter-inbox-filter";
import { BfxBlotterInboxContextMenuService } from "./bfx-blotter-inbox-contextmenu.service";
import { BfxBlotterInboxContextMenu } from "./bfx-blotter-inbox-contextmenu";
import { BfxBlotterInboxService } from "./bfx-blotter-inbox.service";
import { BfxMenusModule } from "app/bfx-menus/bfx-menus.module";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";
import { BaseComponentsModule } from "shared/base-components/base-components.module";

@NgModule({
  declarations: [BfxBlotterInbox, BfxBlotterInboxContextMenu],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    FlexLayoutModule,
    CheckboxModule,
    DialogModule,
    ButtonModule,
    OverlayPanelModule,
    // ag-grid
    AgGridModule.withComponents([]),
    //BFX
    BfxVwapModule,
    BfxSharedModule,
    BfxElementsLibraryModule,
    BaseComponentsModule,
    BfxBlotterFilterModule,
    BfxBlotterOrdersModule,
    BfxMenusModule,
  ],
  providers: [
    BfxBlotterInboxFilter,
    BfxBlotterInboxContextMenuService,
    BfxBaseBlotterColumnSelectorService,
    BfxBlotterInboxService,
  ],
  bootstrap: [BfxBlotterInbox],
})
export class BfxBlotterInboxModule {}
